export const OTHER_SPECIFY_VALUE = 'Other - specify';
